<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'app',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  }
}
</script>

<style>

@import url(http://fonts.googleapis.com/earlyaccess/notosansjapanese.css);
@import "./btn.css";

body{
  font-family: 'Noto Sans JP', sans-serif !important;
  background-image: url("assets/background.png");
  font-size: 150%;
}


/*
  background-size: 150% auto;
  background-position: center center;
  background-repeat: no-repeat;
  background-attachment: fixed;
*/

/*
#loader-bg {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0px;
  left: 0px;
  background-color: #fff;
  z-index: 151;
}
#loader {
  position: fixed;
  top: 50%;
  left: 50%;
  width: 200px;
  height: 200px;
  margin-top: -100px;
  margin-left: -100px;
  text-align: center;
  background: #fff;
  z-index: 152;
}
*/

.row-eq-height {
  display: flex;
  flex-wrap: wrap;
}
</style>
